import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface DeleteDialogProps {
  id: number;
  openConfirm: boolean;
  setOpenConfirm: (value: boolean) => void;
  type: string;
  deleteHandler: (id: number) => void;
}

export const DeleteDialog = ({
  id,
  openConfirm,
  setOpenConfirm,
  type,
  deleteHandler,
}: DeleteDialogProps) => {
  return (
    <Dialog
      open={openConfirm}
      onClose={() => setOpenConfirm(false)}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        Are you sure you want to delete {type}?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          All cards with this {type} would effected.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
        <Button
          onClick={() => {
            deleteHandler(id);
            setOpenConfirm(false);
          }}
          autoFocus
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
